export const paths = {
  home: 'home',
  statements: 'statements',
  statementparents: 'statementparents',
  accountspayable: 'accounting/accounts-payable',
  itemsPosting: 'accouting/items-posting',
  itemGlSetup: 'setup/item-gl-setup',
  itemSetup: 'setup/item-setup',
  storeApGLXref: 'setup/store-ap-gl-xref',
  storeConfig: 'setup/store-config',
  itemGlDetails: 'setup/item-gl-details',
  invoices: 'invoices',
  glCodesSetupTemplate: 'setup/gl-codes-setup-template',
  invoicesearch: 'invoicesearch',
  statementstores: 'statementstores',
  statementinvoices: 'statementinvoices',
  invoiceinvoices: 'invoiceinvoices',
  glguidemenu: 'glguidemenu',
  access_denied: 'access_denied',
  error500: '500',
  logout: 'logout',
  hierarchy: 'setup/hierarchy',
  reports: 'reports',
  reportAccess: 'userAdmin/reportAccess',
  storeAccess: 'userAdmin/storeAccess',
  storeReportGrouping: 'setup/storereportgrouping'
};
